export const SupervisorSummaryTabs = {
  OVERVIEW: "OVERVIEW",
  REPORT: "REPORT",
};
